import React from 'react'
import './style.css'
import { useNavigate } from "react-router-dom";

const BranchDetailsInfoContainer = ({storeName,branchId,addressLine1,addressLine2,addressLine3,city,county,country,postcode,paddingRequired,actionName, actionRequired, navigationLink}) => {
  const navigate = useNavigate();
  return (
    <div className={`branch-details-info-container ${paddingRequired ? 'padding-10' : ''}`}>
        <div className="flex-container">
            <div className="branch-address-details">
                <div className="medium-size-text">{storeName}</div>
                <div className="small-size-text">{addressLine1},{addressLine2}</div>
                <div className="small-size-text">{addressLine3}</div>
                <div className="small-size-text">{city}, {county},{country},{postcode}</div>
            </div>
            {actionRequired && (
          <div className="branch-details-actions">
            <div className="branch-details-btn" onClick={() => navigate(navigationLink+branchId)}>{actionName}</div>
          </div>
        )}
        </div>  
    </div>
  )
}

export default BranchDetailsInfoContainer
